import { render } from "./DropFile.vue?vue&type=template&id=2e35b0e6&ts=true"
import script from "./DropFile.vue?vue&type=script&lang=ts"
export * from "./DropFile.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__